"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FiftyFiftyLayout = require("./FiftyFiftyLayout");
Object.keys(_FiftyFiftyLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FiftyFiftyLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FiftyFiftyLayout[key];
    }
  });
});
